export enum FILTER_VALUES {
    ALL_TIME = 'ALL_TIME',
    LAST_SIX_MONTHS = 'LAST_SIX_MONTHS',
    LAST_TWELVE_MONTHS = 'LAST_TWELVE_MONTHS',
}
